import React from 'react';
import {Container} from 'react-bootstrap';
import InvoiceList from "./InvoiceList";
import CreateInvoice from "./CreateInvoice";
import Analytics from "./Analytics";

function Dashboard({isLoggedIn}) {
    return (
        <Container className="mt-5">
            <h2>Invoice List</h2>

            {/* Creating New Invoice */}
            <CreateInvoice />

            {/* Seller Analytics */}
            {isLoggedIn && <Analytics />}

            {/* Invoice Table */}
            <InvoiceList isLoggedIn={isLoggedIn}/>

        </Container>
    );
}

export default Dashboard;
